<template>
  <div>
    <div class="setting"
         v-for="(setting, key) in productSettings"
         :key="key">
      <div class="setting__title">
        <span class="setting__title--text">
          {{$t('order.' + setting.name)}}
        </span>
      </div>
      <div class="setting__value">
        <div class="setting__value--text">

          <div v-if="setting.type === 'text'">
            <input type="text" v-model="setting.value"/>
          </div>

          <div v-else-if="setting.type === 'carousel' && setting.options !== undefined" class="carousel">
            <VueSlickCarousel v-if="setting.options.length" 
                              v-bind="SliderSettingsProductCustomize(setting.options.length)">
              <div v-for="(slide, index) in setting.options" :key="index">
                <div class="card"
                     v-if="setting.options.length > 0"
                     :class="{'active': setting.value === slide, 'card-disabled': (isUpgrade && !setting.is_upgradable)}"
                     @click="(!isUpgrade) ? selectOption(slide, setting) : (isUpgrade && setting.is_upgradable)? selectOption(slide, setting) : null"
                >
                  <div class="body">
                    <i class="fa-light fa-3x " :class="iconClass(setting.name)"></i>
                    <p class="title">
                      <strong v-if="setting.name != 'ram'">{{slide}} {{setting.unity}}</strong>
                      <strong v-else>{{formatBytes(slide)}}</strong>
                    </p>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
          </div>

          <div v-else-if="setting.type === 'slide'">
            <div class="slide">
              <vuestic-slider
                :options="{
                    min: setting.min_value,
                    max: setting.max_value,
                    interval: setting.step,
                    value: setting.value,
                    tooltip: 'always',
                    tooltip_position: 'bottom',
                    tooltip_split: true,
                    formatter: function(value) {
                      return value + ' ' + setting.unity;
                    },
                  }"
                v-model="setting.value"
                :disabled="(!isUpgrade) ? false : (isUpgrade && !setting.is_upgradable)? true : false"
                @input="(!isUpgrade) ? selectOption(setting.value, setting) : (isUpgrade && setting.is_upgradable)? selectOption(setting.value, setting) : null"
              >
              </vuestic-slider>
            </div>
          </div>

          <div class="toggle" v-else-if="setting.type === 'toggle'">
            <toggle-button :value="!!setting.value"
                           @change="(!isUpgrade) ? changeToggle(setting) : (isUpgrade && setting.is_upgradable)? changeToggle(setting) : null"
                           :disabled="(!isUpgrade) ? false : (!(isUpgrade && setting.is_upgradable))"
                           :width="68"
                           :height="28"
                           :labels="{checked: 'On', unchecked: 'Off'}"
                           color="#45a049"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import {ToggleButton} from 'vue-js-toggle-button'
  // VueSlick Carousel
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // VueSlick Carousel optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import {SliderSettingsProductCustomize} from "./SliderSettings"

  export default {
    name: 'ProductSettings',
    components: {
      ToggleButton,
      VueSlickCarousel
    },
    props: {
      order: {
        type: Object,
        default: () => ({
          datacenter: null,
          category: null,
          template: null,
        })
      },
      productSettings: {
        type: Array
      },
      isUpgrade: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        iconSize: 30,
        slider: {
          formatter: v => `${v}px`,
          min: 20,
          max: 40
        }
      };
    },
    methods: {
      SliderSettingsProductCustomize: SliderSettingsProductCustomize,
      selectOption(option, setting) {
        setting.value = option
        this.$forceUpdate()
        this.$emit('update', setting)
      },
      changeToggle(setting) {
        setting.value = !setting.value
        this.$forceUpdate()
        this.$emit('update', setting)
      },
      iconClass(name) {
        switch (name) {
          case 'vcpus':
            return {'fa-microchip': true};
          case 'ram':
            return {'fa-memory': true};
          case 'storage':
            return {'fa-database': true};
          case 'ipv4':
            return {'fa-router': true};
          case 'backup_slots':
            return {'fa-upload': true};
          case 'bandwidth':
            return {'fa-network-wired': true};
          default:
            return {'fa-microchip': true};
        }
      },
      formatBytes(sizeInMeB) {
        const x = sizeInMeB * Math.pow(1024, 2);
        const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let l = 0, n = parseInt(x, 10) || 0;

        while (n >= 1024 && ++l) {
          n = n / 1024;
        }

        return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
      }
    },
    watch: {
      productSettings: {
        handler: function (val) {
          console.log('productSettings', val)
        },
        deep: true
      },
      isUpgrade: {
        handler: function (val) {
          console.log('isUpgrade', val)
        },
        deep: true
      }
    }
  };
</script>
<style scoped>
  .toggle {
    margin-top: 10px;
    margin-left: 10px;
  }

  .card {
    width: 100px;
    padding: 10px;
    margin: 10px;
  }

  .card:not(.active):hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }

  .card.active {
    border-color: #333;
    box-shadow: black;
    box-shadow: 2px 2px 10px 0px #333;
  }

  .card.card-disabled{
    background-color: #3333;
    border-color: unset;
    box-shadow: none;
    box-shadow: 2px 2px 10px 0px !important;
  }

  .card.card-disabled:not(.active):hover {
    background-color: #3333;
    cursor: default !important;
  }

  /** CSS carroussel */

  .carousel, .slide {
    margin-bottom: 36px;
  }

  .slide {
    margin-top: 32px;
    margin-left: 20px;
  }

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .title {
    margin-top: 20px;
    font-size: 14px;
  }


  /** posso forçar o css em VueCarousel-navigation-next */

  /** css toggle */

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

</style>



// WEBPACK FOOTER //
// src/components/order/ProductSettings.vue